/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BidderStatsDto } from '../../models/bidder-stats-dto';

export interface GetBidderStats$Params {
  bidderIds: string;
  'X-API-Version'?: string;
}

export function getBidderStats(http: HttpClient, rootUrl: string, params: GetBidderStats$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BidderStatsDto>>> {
  const rb = new RequestBuilder(rootUrl, getBidderStats.PATH, 'get');
  if (params) {
    rb.path('bidderIds', params.bidderIds, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BidderStatsDto>>;
    })
  );
}

getBidderStats.PATH = '/api/bidder-stats/{bidderIds}';
